namespace TabAurous.OMS {
    export interface OthersForm {
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        Attribute: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
    }

    export class OthersForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.Others';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OthersForm.init)  {
                OthersForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = CommonCategoryLookup;
                var w2 = CommonSubCategoryLookup;
                var w3 = s.StringEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.BooleanEditor;
                var w6 = s.DateEditor;

                Q.initFormType(OthersForm, [
                    'ProductTypeId', w0,
                    'CategoryId', w1,
                    'SubCategoryId', w2,
                    'ProductCode', w3,
                    'ProductName', w3,
                    'ItemTypeId', w4,
                    'Attribute', w3,
                    'AttributeId', w3,
                    'CalcOnId', w0,
                    'CalcUnitId', w0,
                    'HSN', w0,
                    'TaxCode', w0,
                    'Remarks', w3,
                    'IsDisabled', w5,
                    'ServerDate', w6
                ]);
            }
        }
    }
}
